import React from 'react'

export default function Progress({ loaded, total }) {
    return (
        <div className="progress">
            <div className="progress-bar bg-warning" role="progressbar" style={{ width: `${ (loaded / total) * 100 }%` }}></div>
        </div>
    )
}